
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    RiCheckDoubleLine, RiDraftLine, RiFileListLine,
    RiMoneyDollarCircleLine, RiSearchEyeLine,
} from "react-icons/ri";
import Recruitment from "./Recruitment";
import ResearchActivity from "./ResearchActivity";
import ParticipantCount from "./ParticipantCount";
import Incentives from "./Incentives";
import ParticipantCommunication from "./ParticipantCommunication";
import { FaExchangeAlt } from "react-icons/fa";
import ChangesRequested from "./ChangesRequested";

const TAB_DATA = [
    { id: 1, name: "Recruitment", icon: <RiFileListLine size={20} /> },
    { id: 2, name: "Research Activity", icon: <RiDraftLine size={20} /> },
    { id: 3, name: "Participant Count", icon: <RiSearchEyeLine size={20} /> },
    { id: 4, name: "Incentives", icon: <RiMoneyDollarCircleLine size={20} /> },
    { id: 5, name: "Participant Communication", icon: <RiCheckDoubleLine size={20} /> },
    { id: 6, name: "Changes Requested", icon: <FaExchangeAlt size={20} /> },
];

export default function ResearchDesignTab({ data }) {
    const navigate = useNavigate();

    const urlParams = new URLSearchParams(window.location.search);
    const tabFromURL = urlParams.get("tab");
    const [tab, setTab] = useState(tabFromURL || "1");

    const handleTabChange = (id) => {
        const idStr = String(id);
        setTab(idStr);
        navigate(`?tab=${idStr}`);
    };

    const renderComponent = () => {
        // Pass the server data directly — each child owns its own edit state
        switch (tab) {
            case "1": return <Recruitment projectDetails={data} />;
            case "2": return <ResearchActivity projectDetails={data} />;
            case "3": return <ParticipantCount projectDetails={data} />;
            case "4": return <Incentives projectDetails={data} />;
            case "5": return <ParticipantCommunication projectDetails={data} />;
            case "6": return <ChangesRequested projectDetails={data} />;
            default: return <Recruitment projectDetails={data} />;
        }
    };

    return (
        <div className="w-full mt-5 space-y-4">
            {/* Tab bar */}
            <div className="border-b border-gray-200">
                <div className="flex items-center overflow-x-auto">
                    {TAB_DATA.map((item) => (
                        <button
                            key={item.id}
                            type="button"
                            onClick={() => handleTabChange(item.id)}
                            className={[
                                "flex-shrink-0 flex items-center gap-2 py-3 px-4 text-sm transition-all duration-150 border-b-2",
                                tab === String(item.id)
                                    ? "text-primary border-primary font-semibold"
                                    : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300 font-medium",
                            ].join(" ")}
                        >
                            {item.icon}
                            {item.name}
                        </button>
                    ))}
                </div>
            </div>

            {/* Tab content */}
            {renderComponent()}
        </div>
    );
}